<template>
  <div class="controller u-radius-10 u-overflow-hide">
    <div class="u-flex-column">
      <div style="height: 95%; background: #1b387e; padding: 0 20px; color: #fff">
        <div style="height: 20px"></div>
        <div class="controller-btn u-bg-primary">
          <div style="cursor: pointer" class="u-color-primary u-font-weight u-text-center uu-num" @mousedown="activeBtnItem(0)"
            @mouseup="smControlActive()">停止</div>
          <span
            style="cursor: pointer"
            :class="['btn-item-1', activeBtnItemIndex === 1 ? 'active-btn-item' : '']"
            @mousedown="activeBtnItem(1)"
            @mouseup="smControlActive()"
          ></span>
          <span
            style="cursor: pointer"
            :class="['btn-item-3', activeBtnItemIndex === 3 ? 'active-btn-item' : '']"
            @mousedown="activeBtnItem(3)"
            @mouseup="smControlActive()"
          ></span>
          <span
            style="cursor: pointer"
            :class="['btn-item-5', activeBtnItemIndex === 5 ? 'active-btn-item' : '']"
            @mousedown="activeBtnItem(5)"
            @mouseup="smControlActive()"
          ></span>
          <span
            style="cursor: pointer"
            :class="['btn-item-7', activeBtnItemIndex === 7 ? 'active-btn-item' : '']"
            @mousedown="activeBtnItem(7)"
            @mouseup="smControlActive()"
          ></span>
        </div>
        <div class="u-myflex u-a-center u-color-white u-j-center">
          <span style="cursor: pointer"  @mousedown="activeBtnItem(8)" @mouseup="smControlActive()">
            <i
              class="u-font-lg el-icon-remove-outline"
            ></i>
          </span>
          <div class="u-m5-x-1 u-text-center u-font-lg" style="width: 0.5rem">缩放</div>
          <span style="cursor: pointer"  @mousedown="activeBtnItem(9)" @mouseup="smControlActive()">
            <i
              class="u-font-lg el-icon-circle-plus-outline"
            ></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/web.config.js";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeBtnItemIndex: -1,
      saveForm: {},
      baseUrl: config.cameraUrl,
    };
  },
  methods: {
    sendController(data) {
      console.log(data);
      // if (process.env.NODE_ENV === "production") {
      //   this.$http
      //     .POST_deviceControll(data)
      //     .then((res) => {
      //       console.log(res);
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //     });
      // } else {
      let params = {
        command: data.command,
        horizonSpeed: data.horizonSpeed,
        verticalSpeed: data.verticalSpeed,
        zoomSpeed: data.zoomSpeed,
      }
        let formData = new FormData()
        formData.append("command", data.command)
        formData.append("horizonSpeed", data.horizonSpeed)
        formData.append("verticalSpeed", data.verticalSpeed)
        formData.append("zoomSpeed", data.zoomSpeed)
      console.log('参数',params)
        this.$axios({
          method: "GET",
          headers: { "Content-Type": "multipart/form-data" },
          params: params,
          url: this.baseUrl+'/api/front-end/ptz/'+data.deviceId+'/'+data.channelId,
        }).then((res) => {
          this.saveForm = data;
          console.log(res);
        }).catch((err) => {
          this.$message.error(res.msg);
            console.log(err);
          });;
      //}
    },
    smControlActive() {
      this.activeBtnItemIndex = -1;
      this.saveForm.command = 'stop';
      this.saveForm.verticalSpeed = 0;
      this.saveForm.horizonSpeed = 0;
      this.saveForm.zoomSpeed = 0;
      this.sendController(this.saveForm);
    },
    activeBtnItem(item) {
      //if (!this.data.deviceID) return;
      this.activeBtnItemIndex = item;
      let data = { ...this.data };
      //data.iStop = 0;
      data.verticalSpeed = 0;
      data.horizonSpeed = 0;
      data.zoomSpeed = 0;
      switch (item) {
        case 0:
          console.log("停止");
          //data.iPTZCommand = 21;
          data.command = "stop";
          break;
        case 1:
          console.log("按上");
          //data.iPTZCommand = 21;
          data.command = "up";
          data.verticalSpeed = 50;
          break;
        case 3:
          console.log("按右");
          //data.iPTZCommand = 24;
          data.command = "right";
          data.horizonSpeed = 50;
          break;

        case 5:
          console.log("按下");
          //data.iPTZCommand = 22;
          data.command = "down";
          data.verticalSpeed = 50;
          break;

        case 7:
          console.log("按左");
          //data.iPTZCommand = 23;
          data.command = "left";
          data.horizonSpeed = 50;
          break;
        case 8:
          console.log("缩小");
          //data.iPTZCommand = 12;
          data.command = "zoomout";
          data.zoomSpeed = 4;
          break;
        case 9:
          console.log("放大");
          //data.iPTZCommand = 11;
          data.command = "zoomin";
          data.zoomSpeed = 4;
          break;
      }
      this.sendController(data);
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  height: 42px;
  line-height: 42px;
  padding-left: 20px;
  font-size: 16px;
  color: #fff;
  background-image: linear-gradient(to right, rgb(57, 179, 250), rgba(55, 166, 230, 0.4));
}
.video-div {
  div {
    border: 1px #054b76 solid;
  }
}
.video-name-list {
  width: 50%;
  color: #fff;
}
.controller-btn {
  margin: 0 auto;
  $size: 1.3rem;
  width: $size;
  height: $size;
  border-radius: 100%;
  position: relative;
  background: #115599 !important;
  &::before {
    content: "";
    height: 0;
    display: table;
  }
  $tansY: 0.5rem;
  $sanjiaosize: 0.1rem;
  > div {
    margin: auto;
    margin-top: 50%;
    width: $tansY;
    height: $tansY;
    border-radius: 100%;
    background-color: #fff;
    transform: translate(0, -50%);
    line-height: 0.8rem;
  }

  @for $i from 1 through 12 {
    .btn-item-#{$i} {
      position: absolute;
      border-top: 0 solid rgba(0, 0, 0, 0);
      border-right: $sanjiaosize solid rgba(0, 0, 0, 0);
      border-bottom: $sanjiaosize * 2 solid #fff;
      border-left: $sanjiaosize solid rgba(0, 0, 0, 0);
      top: 50%;
      left: 50%;
      transform: translate($sanjiaosize * -1, $tansY * -1.2) rotate(($i - 1) * 45 + deg);
      transform-origin: $sanjiaosize
        $tansY *
        1.2; /*平移了多少，这里设置原点就反向平移原点*/
    }
  }
  .uu-num {
    line-height: $tansY;
    font-size: 0.22rem;
  }
  .active-btn-item {
    border-top: 0 solid rgba(0, 0, 0, 0);
    border-right: $sanjiaosize solid rgba(0, 0, 0, 0);
    border-bottom: $sanjiaosize * 2 solid #ff0000 !important;
    border-left: $sanjiaosize solid rgba(0, 0, 0, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/camera-controller.vue